import React, {useState, useEffect} from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom'; 
import CartHeader from '../Components/Cart/CartHeader';
import CartItem from '../Components/Cart/CartItem';
//import CartForm from '../Components/Cart/CartForm';
import CartSpedizione from '../Components/Cart/CartSpedizione';
import CartPayments from '../Components/Cart/CartPayments';
import CartSummary from '../Components/Cart/CartSummary';
import CartCheckout from '../Components/Cart/CartCheckout';
import CartInputCoupon from '../Components/Cart/CartInputCoupon';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import g_cfg from "../config";

function ShoppingCart(props) {
  const persistedData = localStorage.getItem('carrello')
  ? JSON.parse(localStorage.getItem('carrello'))
  : {};
  const location = useLocation();
  const history = useHistory();
  /*
  const prefAddress = props.cartData.user && props.cartData.user.indirizzi_spedizione? 
      props.cartData.user.indirizzi_spedizione.find(el => el.preferito === "1") : null;
  */
  const [IsLoading, setIsLoading] = useState(false);
  const [netError, setNetError] = useState(null);
  const [HasMessage, setHasMessage] = useState(null);
  const [CancelItem, setCancelItem] = useState(0);
  const [Coupon, setCoupon] = useState(props.cartData.carrello.codice_sconto === "0"? "" : props.cartData.carrello.codice_sconto);
  const [IsCouponValid, setCouponValid] = useState(props.cartData.carrello.codice_sconto.length > 0 ? true : false);
  const [FormNoCreditUse, setFormNoCreditUse] = useState(false);
  //const [FormPayment, setFormPayment] = useState(props.cartData.carrello.id_pagamento);
  const [FormPayment, setFormPayment] = useState(() => {
/*
    const initialState =
      props.cartData.carrello.id_pagamento !== "0"
        ? props.cartData.carrello.id_pagamento
        : props.cartData.info_aggiuntive.id_pagamento_preferito !== false
        ? props.cartData.info_aggiuntive.id_pagamento_preferito
        : "0";
       
      //console.log("props.cartData.carrello.id_pagamento = " + props.cartData.carrello.id_pagamento);
      //console.log("pagamentoPref = " + props.cartData.info_aggiuntive.id_pagamento_preferito);
      //console.log("initialState = " + initialState);
      return initialState;
*/
    return "0";      
  });
  const [FormShipment, setFormShipment] = useState(props.cartData.carrello.id_spedizione);
  const [FormShipmentInsurance, setFormShipmentInsurance] = useState(
    props.cartData.carrello.assicurato === "1" ? true : false
  );
  const [FormPrivacyAccepted, setFormPrivacyAccepted] = useState(
    props.cartData.info_aggiuntive.flag_privacy > 0 ? false : true
  );
  const [FormConditionsAccepted, setFormConditionsAccepted] = useState(
    props.cartData.info_aggiuntive.flag_condizioni > 0 ? false : true    
  );
  const [RegisterUser, setRegisterUser] = useState(false);
  const [FormAddressId, setFormAddressId] = useState(() => {
/*
    const initialState =
      props.cartData.carrello.id_e_spedizione !== "0"
        ? props.cartData.carrello.id_e_spedizione
        : prefAddress
        ? prefAddress.id_e_user_spedizione
        : "0";
        console.log("props.cartData.carrello.id_e_spedizione = " + props.cartData.carrello.id_e_spedizione);
        console.log("prefAddress = " + prefAddress);
        console.log("initialState = " + initialState);
    return initialState;
*/
    return "0";
  });

  // states for shipment data
  const [FormEmail, setFormEmail] = useState(() => {
    const initialState = props.userData
      ? props.userData.mail
      : "";
    return initialState;
/*
    if (props.cartData.user) {
      return persistedData["mail"] ? persistedData["mail"] : props.cartData.user.dati_principali.mail;
    } else {
      console.log("persisted mail: " + persistedData["mail"]);
      return persistedData["mail"] ? persistedData["mail"] : "";
    }
*/
  });
  const [ValidatedEmail, setValidatedEmail] = useState(() => {
    const initialState = props.userData
      ? props.userData.mail
      : "";
    return initialState;
  });
  const [FormName, setFormName] = useState(persistedData["nome"] ? persistedData["nome"] : "");
  const [FormLastName, setFormLastName] = useState(persistedData["cognome"] ? persistedData["cognome"] : "");
  const [FormPhone, setFormPhone] = useState(persistedData["telefono"] ? persistedData["telefono"] : "");
  const [FormAddress, setFormAddress] = useState(persistedData["indirizzo"] ? persistedData["indirizzo"] : "");
  const [FormCity, setFormCity] = useState(persistedData["citta"] ? persistedData["citta"] : "");
  const [FormProv, setFormProv] = useState(persistedData["provincia"] ? persistedData["provincia"] : "");
  const [FormCap, setFormCap] = useState(persistedData["cap"] ? persistedData["cap"] : "");
  const [FormPresso, setFormPresso] = useState(persistedData["presso"] ? persistedData["presso"] : "");
  const [FormNotes, setFormNotes] = useState(persistedData["note"] ? persistedData["note"] : "");
  const [ErrorList, setErrorList] = useState([]);
/*
  function initStateFromStorage(name) {
    //console.log("INIT " + name);
    //console.log(persistedData);
    return persistedData[name] ? persistedData[name] : ""; 
  }
*/
  function initPayment(cartData) {
    const initialState =
      cartData.carrello.id_pagamento !== "0"
        ? cartData.carrello.id_pagamento
        : cartData.info_aggiuntive.id_pagamento_preferito !== false
        ? cartData.info_aggiuntive.id_pagamento_preferito
        : "0";
      
      if (props.cfg.debug === true) {
        console.log("cartData.carrello.id_pagamento = " + cartData.carrello.id_pagamento);
        console.log("pagamentoPref = " + cartData.info_aggiuntive.id_pagamento_preferito);
        console.log("initialState pment = " + initialState);
      }
      return initialState;
  }

  function initAddressId(cartData, prefAddress) {
    const initialState =
    cartData.carrello.id_e_spedizione !== "0" && cartData.carrello.id_e_spedizione != null
      ? cartData.carrello.id_e_spedizione
      : prefAddress !== null && prefAddress !== undefined
      ? prefAddress.id_e_user_spedizione
      : "0";
      if (props.cfg.debug === true) {
        console.log("cartData.carrello.id_e_spedizione = " + cartData.carrello.id_e_spedizione);
        console.log("prefAddress = " + prefAddress);
        console.log("initialState addrid = " + initialState);
      }
    return initialState;
  }

  const paymentShipmentRequirements = {
    "6": {
      requires: ["2"],
      //msg: "il pagamento in contanti in sede è accettato solo se la spedizione è 'ritiro in sede'",
      msg: "Seleziona una forma di pagamento",
    },
  };
/*
  useEffect(() => {
    //window.scrollTo(0, 0);
    loadCart();
  }, []);
*/
  useEffect(() => {
    window.scrollTo(0, 0);
    loadCart();
  }, [location.key]);

  // persist local form data
  useEffect(() => {
    //console.log("STORE");
    var obj = props.userData && props.userData.id_e_user.length > 0 && props.userData.id_e_user !== "0"? createStateObjRegistered() : createStateObjUnregistered();
    //console.log(obj);
    localStorage.setItem('carrello', JSON.stringify(obj));
  }, [FormEmail, FormName, FormLastName, FormAddress, FormAddressId, FormPresso, FormCity, FormProv, FormCap, FormPhone, FormNotes]);

  function closeMessageHandler() {
    setHasMessage(null);
  }
  function closeErrorHandler() {
    setNetError(null);
  } 
  function cancelRemovalHandler() {
    setCancelItem(0);
  }
  function removalHandler(itemID) {
    setCancelItem(itemID);
  }
  function removalConfirmedHandler(itemID) {
    setCancelItem(0);
    removeItem(itemID);
  }

  function loadCart() {
    let params = [
      {name: "session", value: props.sessionKey},
      {name: "id_e_user", value: props.userData? props.userData.id_e_user.toString() : "0"}
    ];
    props.wsCall("https://ws.mediatoys.it/carrello/cart_detail", IsLoading, setIsLoading, netError, setNetError, params, (respData) => {
      props.cartUpd(respData.data); 
      setFormPayment(initPayment(respData.data));   
      const prefAddress = respData.data.user && respData.data.user.indirizzi_spedizione? 
        respData.data.user.indirizzi_spedizione.find(el => el.preferito === "1") : null;
      //console.log("wsCall->prefAddress = "+prefAddress);
      setFormAddressId(initAddressId(respData.data, prefAddress));
    });
  }

  function emptyCart() {
    let params = [
      {name: "session", value: props.sessionKey},
      //{name: "id_e_user", value: props.userData? props.userData.id_e_user.toString() : "0"}
    ];
    props.wsCall("https://ws.mediatoys.it/carrello/svuota", IsLoading, setIsLoading, netError, setNetError, params, (respData) => {
      if (respData.status === true && respData.message === "OK")  {
        setHasMessage(respData.message);
      }
      props.cartUpd(respData.data);
    });    
  }

  function removeItem(productId) {
    let params = [
      {name: "session", value: props.sessionKey},
      //{name: "id_utente", value: props.userData? props.userData.id_e_user.toString() : "0"},
      {name: "id_e_products", value: productId.toString()},
      {name: "id_e_products_models", value: "0"}
    ];
    props.wsCall("https://ws.mediatoys.it/carrello/cart_delete_product", IsLoading, setIsLoading, netError, setNetError, params, (respData) => {
      props.cartUpd(respData.data);
    });    
  }

  function addItemQty(productId, qty) {
    let params = [
      {name: "session", value: props.sessionKey},
      {name: "id_utente", value: props.userData? props.userData.id_e_user.toString() : "0"},
      {name: "id_e_products", value: productId.toString()},
      {name: "id_e_products_models", value: "0"},
      {name: "quantita_carrello", value: qty.toString()}
    ];
    props.wsCall("https://ws.mediatoys.it/carrello/add", IsLoading, setIsLoading, netError, setNetError, params, (respData) => {
      props.cartUpd(respData.data);
    });    
  }

  function applyCoupon() {
    if (Coupon.length === 0) {
      // no check, just set coupon to null
      if (props.cartData.carrello.codice_sconto.length > 0 && props.cartData.carrello.codice_sconto !== "0") {
        // invoke ws to remove discount code
        setCartData("codice_sconto", "0", (respData) => {
          if (respData.status === true)  {
            props.cartUpd(respData.data);
            setHasMessage("Sconto rimosso");
          } else {
            setCouponValid(false);
            setHasMessage(respData.message);
          }
        });
      }
      setCouponValid(false);
      return;
    }

    let params = [
      {name: "session", value: props.sessionKey},
      {name: "discount_code", value: Coupon},
    ];   
    // invoke ws to apply discount code
    props.wsCall("https://ws.mediatoys.it/carrello/verifica_codice_sconto", IsLoading, setIsLoading, netError, setNetError, params, (respData) => {
      if (respData.status === true)  {
        setCouponValid(true);
        setCartData("codice_sconto", Coupon, (respData) => {
          if (respData.status === true)  {
            props.cartUpd(respData.data);
            setHasMessage("Sconto applicato");
          } else {
            setCouponValid(false);
            setHasMessage(respData.message);
          }              
        });
      } else {
        setCouponValid(false);
        setHasMessage(respData.message);
        setCartData("codice_sconto", "0");
      }
    });
    
  }

  function setCartData(paramName, paramValue, action = null) {
    let params = [
      {name: "session", value: props.sessionKey},
      {name: "field", value: paramName},
      {name: "value", value: paramValue.toString()},
    ];
    props.wsCall(
      "https://ws.mediatoys.it/carrello/setCartData",
      IsLoading, setIsLoading, netError, setNetError,
      params,
      action === null
        ? (respData) => {
            if (respData.status === true) {
              props.cartUpd(respData.data);
            } else {
              setHasMessage(respData.message);
            }
          }
        : (respData) => action(respData)
    );
  }

  function setShipment(shipmentId) {
    setFormShipment(shipmentId);
    setCartData("id_spedizione", shipmentId);
  }
  function setShipmentInsurance(boolVal) {
    setFormShipmentInsurance(boolVal);
    let val = boolVal === true? "1" : "0";
    setCartData("assicurato", val);
  }
  function setPayment(paymentId) {
    setFormPayment(paymentId);
    setCartData("id_pagamento", paymentId);
  }
  function setAddressId(addressId) {
    setFormAddressId(addressId);
    setCartData("id_e_spedizione", addressId);
  } 
  function setCreditUse(dontUseCredit) {
    setFormNoCreditUse(dontUseCredit);
    setCartData("usa_credito", dontUseCredit === true? "0" : "1");  // swap value
  }
/*
  function manageItemList() {
    if (
      props.cartData != null &&
      props.cartData.prodotti != null &&
      props.cartData.prodotti.length > 0
    ) {

      return props.cartData.prodotti.map((item) => (
        // Without the `key`, React will fire a key warning
        <CartItem
          key={"ict_" + item.id_e_products}
          item={item}
          urlItem={
            "/"+g_cfg.catalogSlug+"/" +
            item.details[0].category.find(el => el.livello && el.livello === "2").slug +
            "/"+
            item.details[0].slug +
            "/" +
            item.id_e_products
          }
//          urlImg={props.cfg.urlItemImg +item.img}
          urlImg={item.details[0].images[0].url}
          itemRemoval={removalHandler}
          //updateQty={addItemQty}  // funzione da cambiare
          incrementQty={addItemQty}
          convert={props.cfg.convert}
        />
      ));
    } else {
      return null;
    }
  }
*/
  function manageItemList() {
    if (
      props.cartData != null &&
      props.cartData.prodotti != null &&
      props.cartData.prodotti.length > 0
    ) {

      return props.cartData.prodotti.map((item) => {
        let category = item.details[0].category.find((el) => el.livello && el.livello === "2");
        if (!category) {
          category = {
            slug: "burago",
            id_category_list: "5",
          }
        }
              
        return (
        // Without the `key`, React will fire a key warning
        <CartItem
          key={"ict_" + item.id_e_products}
          item={item}
          urlItem={
            "/"+g_cfg.catalogSlug+"/" +
            category.slug +
            "/"+
            item.details[0].slug +
            "/" +
            item.id_e_products
          }
//          urlImg={props.cfg.urlItemImg +item.img}
          urlImg={item.details[0].images[0].url}
          itemRemoval={removalHandler}
          //updateQty={addItemQty}  // funzione da cambiare
          incrementQty={addItemQty}
          convert={props.cfg.convert}
        />
      )}
      );
    } else {
      return null;
    }
  }

  function removeConfirmDialog(itemID) {
     return (
      <Dialog open={true} /*onEnter={console.log("Hey.")}*/ >
        <DialogTitle>Vuoi rimuovere l'articolo?</DialogTitle>
        <DialogContent>
          <p>Premendo Ok l'articolo verrà rimosso dal carrello</p>
          <div className="rimuovi_popup_button" onClick={() => removalConfirmedHandler(itemID)}>Ok</div>
          <div className="cancel_popup_button" onClick={() => cancelRemovalHandler()} >Cancel</div>
        </DialogContent>
      </Dialog>
      );
  }

  function messageDialog(text) {
    return (
      <Dialog open={true}>
        <DialogContent>
          <p>{text}</p>
          <div className="chiudi_popup_button" onClick={() => closeMessageHandler()}>Chiudi</div>
        </DialogContent>
      </Dialog>
    )
  }
  function errorDialog(text) {
    return (
      <Dialog open={true}>
        <DialogContent>
          <p>{text}</p>
          <div className="chiudi_popup_button" onClick={() => closeErrorHandler()}>Chiudi</div>
        </DialogContent>
      </Dialog>
    )
  }

  if (props.userData && props.cartData.user && props.userData.id_e_user !== props.cartData.user.dati_principali.id_e_user) {
    //console.log("User Mismatch: "+props.userData.id_e_user+" - "+props.cartData.user.dati_principali.id_e_user);
  }

  function checkTextValue(txt, fieldName, special = "") {
    if (txt.trim().length === 0)
      //return fieldName + " deve avere valore valido";
      return "Si prega di non lasciare il campo vuoto.";
    if (special === "email") {
      // controllo aggiuntivo: verifichiamo che il valore in FormEmail sia uguale all'ultimo validato con successo
      if (txt !== ValidatedEmail)
        return "Inserire un indirizzo di email valido.";
    }
    if (special === "phone") {
      if (!txt.match(/^[0-9\s(+)-]*$/)) {
        return "Inserire un numero di telefono valido.";
      }
      if (txt.length < 8) {
        return "Numero troppo corto.";
      }
    }

    return "";
  }

  function createStateObjUnregistered() {
    var obj = {
      mail: FormEmail,
      nome: FormName,
      cognome: FormLastName,
      indirizzo: FormAddress,
      presso: FormPresso,
      citta: FormCity,
      provincia: FormProv,
      cap: FormCap,
      telefono: FormPhone,
      note: FormNotes,
      privacyAccepted: FormPrivacyAccepted,
      conditionsAccepted: FormConditionsAccepted,
    };

    return obj;
  }

  function createStateObjRegistered() {
    var obj = {
      mail: FormEmail,
      //nome: FormName,
      //cognome: FormLastName,
      //indirizzo: FormAddress,
      //presso: FormPresso,
      //citta: FormCity,
      //provincia: FormProv,
      //cap: FormCap,
      //telefono: FormPhone,
      idIndirizzo: FormAddressId,
      note: FormNotes,
      privacyAccepted: FormPrivacyAccepted,
      conditionsAccepted: FormConditionsAccepted,
    };

    return obj;
  }

  function validateCart() {
    // step 1: collect all data (done: in state variables)    
    // step 2: validate data
    let errList = [];
    let res = "";
    if (props.userData && props.cartData.user && props.userData.id_e_user !== props.cartData.user.dati_principali.id_e_user) {
      //console.log("User Mismatch: "+props.userData.id_e_user+" - "+props.cartData.user.dati_principali.id_e_user);
      errList.push({id: "all", msg: "Id utente non corrisponde"}); 
    }

    // 2.1: controlli anagrafica:
    if (props.cartData.user && props.cartData.user.dati_principali.id_e_user.length > 0 && props.cartData.user.dati_principali.id_e_user !== "0") {
      // registered and logged in: verificare solo che l'id dell'indirizzo di spedizione sia valido
      //console.log("FormAddressId = "+FormAddressId);
      res = checkTextValue(FormEmail, "Indirizzo Email", "email");
      if (res !== "") 
        errList.push({id: "Email", msg: res}); 
      if (FormAddressId !== props.cartData.carrello.id_e_spedizione) {
        errList.push({id: "AddressId", msg: "Incongruenza nel codice di indirizzo di spedizione. Si prega di reimpostarlo."});
      } else if (props.cartData.user.indirizzi_spedizione.findIndex((el) => el.id_e_user_spedizione === FormAddressId) < 0) {
        if (props.cartData.user.indirizzi_spedizione.length > 0)
          errList.push({id: "AddressId", msg: "Indirizzo di spedizione non valido. Si prega di reimpostarlo."});
        else
          errList.push({id: "AddressId", msg: "Nessun indirizzo di spedizione registrato. Si prega di aggiungerlo."});
      }
    } else {
      // unregistered / not logged in: verifica dati del form 
      // Mancano:
      //    - verifica email (formato e non già registrato)
      //    - verifica telefono (solo cifre, " " e "-")
      //    - verifica provincia (deve essere presente nella lista province)
      res = checkTextValue(FormName, "Nome");
      if (res !== "") errList.push({id: "Name", msg: res});
      res = checkTextValue(FormLastName, "Cognome");
      if (res !== "") errList.push({id: "LastName", msg: res});
      res = checkTextValue(FormPhone, "Telefono", "phone");
      if (res !== "") errList.push({id: "Phone", msg: res});
      res = checkTextValue(FormAddress, "Indirizzo");
      if (res !== "") errList.push({id: "Address", msg: res});
      res = checkTextValue(FormCity, "Città");
      if (res !== "") errList.push({id: "City", msg: res});
      res = checkTextValue(FormCap, "CAP");
      if (res !== "") errList.push({id: "Cap", msg: res});
      res = checkTextValue(FormProv, "Provincia");
      if (res !== "") errList.push({id: "Province", msg: res});
      res = checkTextValue(FormEmail, "Indirizzo Email", "email");
      if (res !== "") errList.push({id: "Email", msg: res}); 
    }

    // 2.2: controllo codice spedizione
    if (FormShipment !== props.cartData.carrello.id_spedizione) {
      errList.push({id: "Shipment", msg: "Incongruenza nel codice di tipo spedizione. Si prega di reimpostarlo."});
    } else if (FormShipment.trim().length === 0 || FormShipment === "0") {
      errList.push({id: "Shipment", msg: "Tipo di spedizione non valido. Si prega di reimpostarlo."});
    }      

    // 2.2: controllo codice pagamento
    //console.log("FormPayment = "+FormPayment +" - "+typeof(FormPayment) + " - " + props.cartData.carrello.id_pagamento);
    if (FormPayment !== props.cartData.carrello.id_pagamento) {
      errList.push({id: "Payment", msg: "Incongruenza nel codice di pagamento. Si prega di reimpostarlo."});
    } else if (FormPayment.trim().length === 0 || FormPayment === "0") {
      errList.push({id: "Payment", msg: "E' necessario scegliere un tipo di pagamento per proseguire."});
    }      

    // 2.3: controllo compatibilità codici spedizione e pagamento
    if (paymentShipmentRequirements[FormPayment] && paymentShipmentRequirements[FormPayment].requires.indexOf(FormShipment) < 0) {
      // il pagamento è possibile solo con alcuni tipi di spedizione, e non c'è match
      errList.push({id: "Payment", msg: paymentShipmentRequirements[FormPayment].msg});
    } 

    // 2.4: verifica assicurazione pacco
    if ((FormShipmentInsurance === true && props.cartData.carrello.assicurato !== "1") && (FormShipmentInsurance === false && props.cartData.carrello.assicurato !== "0")) {
      errList.push({id: "ShipmentInsurance", msg: "Incongruenza nel codice di assicuazione del pacco. Si prega di reimpostarlo."});
    }
 
    // 2.5: verifica non utilizzo credito
    if ((FormNoCreditUse === true && props.cartData.carrello.usa_credito !== "0") || (FormNoCreditUse === false && props.cartData.carrello.usa_credito !== "1")) {  // valori scambiati
      errList.push({id: "NoCreditUse", msg: "Incongruenza nella scelta di non utilizzare il credito. Si prega di reimpostarlo."});
    }
 
    // 2.6: verifica Coupon
    if ((Coupon.trim().length >0 && Coupon !== props.cartData.carrello.codice_sconto) || (Coupon.trim().length === 0 && props.cartData.carrello.codice_sconto !== "0")) {
      if ((Coupon.length === 0) && (props.cartData.carrello.codice_sconto.length > 0 && props.cartData.carrello.codice_sconto !== "0")) {
        errList.push({id: "Coupon", msg: "Nel carrello è memorizzato un codice sconto non visualizzato. Premere il pulsante Applica col campo vuoto per rimuoverlo."});
      } else if ((Coupon.length > 0) && (props.cartData.carrello.codice_sconto.length === 0 && props.cartData.carrello.codice_sconto.length === "0")) {
        errList.push({id: "Coupon", msg: "Il codice sconto visualizzato non è stato applicato al carrello. Premere il pulsante Applica per caricarlo."});
      } else {
        errList.push({id: "Coupon", msg: "Il codice sconto visualizzato è diverso da quello applicato al carrello. Premere il pulsante Applica per utilizzare il codice di sconto visualizzato."});
      }
    }

    // 2.7: accettazione privacy (se richiesto)
    if (props.cartData.info_aggiuntive.flag_privacy === 1 && FormPrivacyAccepted !== true) {
      errList.push({id: "CkPrivacy", msg: "E' necessario accettare la privacy policy per proseguire."});
    }
  
    // 2.8: accettazione condizioni di vendita (se richiesto)
    if (props.cartData.info_aggiuntive.flag_condizioni === 1 && FormConditionsAccepted !== true) {
      errList.push({id: "CkConditions", msg: "E' necessario accettare le condizioni di vendita per proseguire."});
    }

    return errList;
  }
/*
url ringraziamento ordine campione
https://localhost:3001/thankyou/SlpTNGJja2JPcUVUOXhNanQ4UDRHUT09
https://localhost:3001/thankyou/aGlvdkFmMnRmTzBJM2ZBZDZhSUszdz09
*/

  // order redirect
  function orderRedirect(url_payment, id_e_order_crypt) {
    if (FormPayment === "1")  {
      // pagamento con carta di credito
      if (url_payment && url_payment.carta_di_credito && url_payment.carta_di_credito.length > 0) {
        window.location.replace(url_payment.carta_di_credito);
      }
    } else if (FormPayment === "2")  {
      // pagamento con PayPal
      if (url_payment && url_payment.paypal && url_payment.paypal.length > 0) {
        window.location.replace(url_payment.paypal);
      }
    } else {
      // step 5: redirect to thankyou page (optional)
      history.push("/thankyou/"+id_e_order_crypt);
    }    

  }
  
  // conferma ordine
  function confirmOrderHandler() {
    let errList = validateCart();

    setErrorList(errList);
    //console.log(errList);

    if (errList.length > 0) {
      setHasMessage("La compilazione del carrello è incompleta. Segui le indicazioni e riprova!");
      return;
    }

    // step 3: send order via ws
    var obj = props.userData && props.userData.id_e_user.length > 0 && props.userData.id_e_user !== "0"? createStateObjRegistered() : createStateObjUnregistered();
    
    if (props.cfg.debug === true) {
      console.log(obj);
    }

    let params = [
      {name: "session", value: props.sessionKey},
      {name: "id_e_user", value: props.userData? props.userData.id_e_user.toString() : "0"},
      {name: "data_obj", value: JSON.stringify(obj)},
    ];   
    props.wsCall("https://ws.mediatoys.it/order/addOrdine", IsLoading, setIsLoading, netError, setNetError, params, (respData) => {
      // step 4: redirect for payment (optional) 
      //console.log(respData);
      if (respData.status === false) {
        // operation failed
        setHasMessage(respData.message);
        return;
      }
      
      // se id_user attuale assente o "0", facciamo un login silente caricando il profilo utente mediante https://ws.mediatoys.it/cliente/dettaglio_cliente
      if (props.userData && props.userData.id_e_user.length > 0 && props.userData.id_e_user !== "0") {
        // registered & logged in customer => proceed to redirect (NEW: first, update user cart data)
        orderRedirect(respData.data.url_payment, respData.data.ordine[0].id_e_order_crypt);
/*
        let pars = [
          {name: "id_e_user", value: props.userData.id_e_user},
        ];   
        props.wsCall("https://ws.mediatoys.it/cliente/dettaglio_cliente", IsLoading, setIsLoading, netError, setNetError, pars, (respData2) => {
          //console.log(respData2);
          props.userUpdate(respData2.user.dati_principali);
          //localStorage.setItem("storedUserData", JSON.stringify(respData2.user.dati_principali));        
          orderRedirect(respData.data.url_payment, respData.data.ordine[0].id_e_order_crypt);
        });

        let params = [
          {name: "session", value: props.sessionKey},
          {name: "id_e_user", value: props.userData? props.userData.id_e_user.toString() : "0"}
        ];
        props.wsCall("https://ws.mediatoys.it/carrello/cart_detail", IsLoading, setIsLoading, netError, setNetError, params, (respData2) => {
          props.cartUpd(respData2.data); 
          orderRedirect(respData.data.url_payment, respData.data.ordine[0].id_e_order_crypt);
        });
*/        
    
      } else {
        // step 4+: unregistered customer => silent registration => update user data before redirect
        let pars = [
          {name: "id_e_user", value: respData.data.ordine[0].id_e_user.toString()},
        ];   
        props.wsCall("https://ws.mediatoys.it/cliente/dettaglio_cliente", IsLoading, setIsLoading, netError, setNetError, pars, (respData2) => {
          //console.log(respData2);
          props.userUpdate(respData2.user.dati_principali);
          localStorage.setItem("storedUserData", JSON.stringify(respData2.user.dati_principali));        
          orderRedirect(respData.data.url_payment, respData.data.ordine[0].id_e_order_crypt);
        });
       }
    });
   
  }
 
  //console.log(props.userData);
  //console.log("AddressId = "+FormAddressId);
  //console.log("Email: " + FormEmail);
  if (!IsLoading && props.cartData && (!props.cartData.prodotti || props.cartData.prodotti.length === 0)) {
    return (
      <>
        <h1 className="titolo_pagina">Il carrello è vuoto</h1>
        <p className="link_torna_articoli">
          <Link to={"/"+g_cfg.catalogSlug}>Torna ai prodotti</Link>
        </p>
      </>
    );
  }

  return (
    <>
      {IsLoading === true ? (
        <div className="spinner">
          <img src="/images/waiting.gif" alt="operazione in corso ..." />
        </div>
      ) : null}

      {netError !== null ? errorDialog(netError) : null}

      <div className="contenitore_cart">
        <div className="titolo_cart">
          <h1>Il Tuo carrello:</h1>
          <div className="ico_titolo_cart">
            <div className="torna_shop">
              <Link to={"/"+g_cfg.catalogSlug}>
                <div className="torna_shop_img">
                  <img
                    src="/images/continua_shopping_on.svg"
                    alt="Continua shopping"
                    title="Continua shopping"
                  />
                </div>
                <p>Continua lo shopping</p>
              </Link>
            </div>
            <div className="svuota_cart" onClick={() => emptyCart()}>
              <div className="svuota_cart_img">
                <img
                  src="/images/cestino_on.svg"
                  alt="Svuota carrello"
                  title="Svuota carrello"
                />
              </div>
              <p>Svuota il carrello</p>
            </div>
          </div>
        </div>
        <div className="colonna-01_cart">
          <div className="tabella_articoli_cart">
            <CartHeader />
            {manageItemList()}
            {CancelItem > 0 ? removeConfirmDialog(CancelItem) : null}
            {netError !== null ? errorDialog(netError) : null}
            {HasMessage !== null ? messageDialog(HasMessage) : null}

            <div className="coupon_cart">
              <img
                src="/images/coupon.svg"
                alt="Codice sconto"
                title="Codice sconto"
              />
              <p>Hai un codice sconto?</p>
            </div>
            <CartInputCoupon
              required={false}
              type="text"
              lbl="Inserisci il codice sconto nel campo seguente per aggiungerlo al carrello."
              btnLbl="APPLICA"
              name="Coupon"
              value={Coupon}
              change={setCoupon}
              apply={applyCoupon}
              cssClass="cod_sconto_cart"
              errList={ErrorList}
            />
          </div>

          <CartSpedizione
            cartData={props.cartData}
            title="Informazioni di spedizione"
            token={props.token}
            tokenUpdate={props.tokenUpdate}
            sessionKey={props.sessionKey}
            valueEmail={FormEmail}
            validatedEmail={ValidatedEmail}
            changeValidatedEmail={setValidatedEmail}
            valuePhone={FormPhone}
            valueName={FormName}
            valueLastName={FormLastName}
            valueAddress={FormAddress}
            valueCity={FormCity}
            valueProv={FormProv}
            valueCap={FormCap}
            valuePresso={FormPresso}
            valueNotes={FormNotes}
            valueShipment={FormShipment}
            valueShipmentInsurance={FormShipmentInsurance}
            valueAddressId={FormAddressId}
            changeEmail={setFormEmail}
            changePhone={setFormPhone}
            changeName={setFormName}
            changeLastName={setFormLastName}
            changeAddress={setFormAddress}
            changeCity={setFormCity}
            changeProv={setFormProv}
            changeCap={setFormCap}
            changePresso={setFormPresso}
            changeNotes={setFormNotes}
            changeShipment={setShipment}
            changeShipmentInsurance={setShipmentInsurance}
            changeAddressId={setAddressId}
            provinceList={props.provinceList}
            errList={ErrorList}
            cfg={props.cfg}
          />

          <CartPayments
            cartData={props.cartData}
            title="Metodo di pagamento"
            value={FormPayment}
            change={setPayment}
            shipmentId={FormShipment}
            errList={ErrorList}
          />
        </div>

        <CartSummary
          cartData={props.cartData}
          creditOption={FormNoCreditUse}
          changeCreditOption={setCreditUse}
          convert={props.cfg.convert}
          errList={ErrorList}
        />
        <div className="clear"></div>
      </div>

      <div className="chiusura_cart">
        <CartCheckout
          cartData={props.cartData}
          privacyOption={FormPrivacyAccepted}
          changePrivacyOption={setFormPrivacyAccepted}
          conditionsOption={FormConditionsAccepted}
          changeConditionsOption={setFormConditionsAccepted}
          registerOptionOn={!props.cfg.cartSilentRegister}
          registerOption={RegisterUser}
          changeRegisterOption={setRegisterUser}
          loggedIn={
            //props.userData && props.userData.isLoggedIn === true ? true : false
            props.cartData.user && props.cartData.user.dati_principali.id_e_user !== "0"
              ? true
              : false
          }
          confirmOrder={confirmOrderHandler}
          privacyUrl={props.cfg.iubendaPrivacyUrl}
          errList={ErrorList}
        />

        <div className="clear"></div>
      </div>
     </>
  );
}

export default ShoppingCart;